// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__2isxd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Logo/Logo.css
// module id = 68
// module chunks = 16